$(document).ready(function () {
  window.firstLoad = true;
  setTimeout(() => {
    if (window.firstLoad) {
      initBYOB();
      window.firstLoad = false;
    }
  }, 1000);
  document.addEventListener("cart_refresh", function (event) {
    loadTrackerBYOB();
    loadCartBYOB();
    loadProductBYOB();
    $("#byob-summary").css("bottom", "0%");
  });
  $(document).on("click", ".add-to-byob", function (e) {
    let product = $(this).closest(".byob-product");
    let cart = myApiCart(this);
    cart.addItem({
      id: product.data("product-options").VariantFirstID,
      properties: { Bundle: "BYOB" },
    });
  });
  $(document).on("click", ".byob-quantity-selector", function (e) {
    let product = $(this).closest(".byob-product");
    let input = product.find(".t4s-quantity-input");
    let quantity = input.val();
    if ($(this).hasClass("is--minus")) {
      quantity = quantity > 0 ? quantity - 1 : 0;
    } else {
      quantity++;
    }
    let cart = myApiCart(this);
    cart.updateItem({
      id: product.data("key"),
      quantity: quantity,
    });
  });
  $(document).on("click", ".remove-byob", function (e) {
    let item = $(this).closest(".item-holder");
    let cart = item.closest("#byob-cart");
    cart.addClass("disabled");
    item.find(".item-holder-inner-wrapper").addClass("byob-loading");
    MyAPI.cart.deleteItem(item.data("id"), (res) => {
      try {
        T4SThemeSP.Cart.getToFetch();
      } catch (e) {}
    });
  });
  $(document).on("click", ".byob-btn-checkout", function (e) {
    $(this).addClass("disabled");
    window.location.href = "/checkout";
  });
  function loadCartBYOB() {
    let byob_cart = $("#byob-cart");
    let cart = getCartBYOB();
    let count = cart.items.length;
    for (let i = 0; i < count; i++) {
      let item = cart.items[i];
      addCartBYOB(byob_cart.find(".item-holder")[i], item);
    }
    let has_items = byob_cart.find(".item-holder[title]");
    for (let i = count; i < has_items.length; i++) {
      emptyCartBYOB(has_items[i]);
    }
    let no_items = byob_cart.find(".item-holder:not([title])");
    if (no_items.length == 0) {
      emptyCartBYOB(has_items[0], false);
      no_items = byob_cart.find(".item-holder:not([title])");
    }
    if (has_items.length > 7 && no_items.length > 1) {
      for (let i = 1; i < no_items.length; i++) {
        $(no_items[0]).remove();
      }
    }
    byob_cart.find(".item-holder:not([title]):first .plus").addClass("first");
    byob_cart.removeClass("disabled");
    $("#byob-btn-checkout").toggleClass("disabled", count == 0);
  }
  function addCartBYOB(element, item) {
    element = $(element);
    const getNameImage = (src) => {
      let m = /[^\/\\&\?]+\.\w{3,4}(?=([\?&].*$|$))/.exec(src);
      return m !== null ? m[0] : "";
    };
    element.attr("data-id", item.key).data("id", item.key);
    element.attr("title", item.product_title);
    let inner_wrapper = element.find(".item-holder-inner-wrapper");
    inner_wrapper.removeClass("byob-loading");
    let pro_img = inner_wrapper.find(".product-img");
    let pro_img_name = "";
    if (pro_img) {
      pro_img_name = getNameImage(pro_img.data("src"));
    }
    if (getNameImage(item.image) != pro_img_name) {
      inner_wrapper.html(
        `<span class="item-qty" title="Quantity">` +
          item.quantity +
          `</span><img class="product-img lazyloadt4s t4s-obj-eff t4s-lz--fadeIn" src="` +
          item.image +
          `&width=1" data-src="` +
          item.image +
          `&width=200" width="200" height="200" alt="` +
          item.product_title +
          `"><img class="remove-byob" src="/cdn/shop/t/40/assets/remove-icon.svg" width="15" height="15" title="Remove" alt="Remove">`
      );
    } else {
      inner_wrapper.find(".item-qty").html(item.quantity);
    }
  }
  function emptyCartBYOB(element, remove = true) {
    element = $(element);
    let element2 = $(element).clone(true);
    element2.removeAttr("data-id");
    element2.removeAttr("title");
    let inner_wrapper = element2.find(".item-holder-inner-wrapper");
    inner_wrapper.removeClass("byob-loading");
    inner_wrapper.html(
      `<div class="plus">` +
        `<div class="cut-out"></div>`.repeat(4) +
        `</div><span class="empty-text">Add Something</span>`
    );
    element.parent().append(element2);
    if (remove) {
      element.remove();
    }
    return element2;
  }
  function loadTrackerBYOB() {
    let cart = getCartBYOB();
    let byob_tracker = $("#byob-tracker");
    let trackers = byob_tracker.find(".box");
    var j = 0;
    for (let i = trackers.length - 1; i > 0; i--) {
      let tracker = $(trackers[i]);
      let percent = cart.total / tracker.data("point");
      let percent_pre = cart.total / $(trackers[i - 1]).data("point");
      if (percent < 100 && percent_pre < 100) {
        j = setTrackerBYOB(tracker, 0, j);
      } else {
        break;
      }
    }
    let point_start = byob_tracker.find(".point.start");
    if (cart.total) {
      point_start.addClass("active");
    } else {
      point_start.removeClass("active");
    }
    let completed = 0;
    let byob_discount_value = 0;
    let byob_discount_type = "";
    let byob_discount_name = "";
    let pre_track = null;
    for (let i = 0; i < trackers.length; i++) {
      let tracker = $(trackers[i]);
      let process = tracker.find(".process");
      let point = tracker.data("point");
      if (pre_track) {
        point -= pre_track.data("point");
      }
      let percent = cart.total / point;
      if (checkTrackerBYOB(tracker, cart.ids)) {
        if (percent >= 100) {
          completed++;
          if (tracker.data("discount-value")) {
            byob_discount_value = tracker.data("discount-value");
            byob_discount_type = tracker.data("discount-type");
          } else {
            byob_discount_name = tracker.data("label");
          }
          if (process.css("width") != "100%") {
            cart.total -= point * 100;
            pre_track = tracker;
            j = setTrackerBYOB(tracker, 100, j);
          }
        } else {
          if (process.css("width") != percent + "%") {
            j = setTrackerBYOB(tracker, percent, j);
          }
          break;
        }
      } else {
        j = setTrackerBYOB(tracker, percent >= 100 ? 99 : percent, j);
        break;
      }
    }
    let check_promotion =
      byob_discount_value > 0 && completed == trackers.length;
    if (check_promotion) {
      let discount_value = 0;
      if (byob_discount_type == "percent") {
        for (let k = 0; k < cart.totals.length; k++) {
          discount_value += cart.totals[k] * byob_discount_value * 0.01;
        }
      }
      if (byob_discount_type == "fixed") {
        discount_value = currencyWithRate(byob_discount_value * 100);
      }
      byob_discount_name = "Save " + formatCC(cart.total - discount_value);
    }
    let byob_message = $(".byob-description-message");
    byob_message.find(".byob-description").toggle(!check_promotion);
    byob_message.find(".byob-message").toggle(check_promotion);

    let byob_summary = $(".byob-summary");
    byob_summary
      .find("#byob-items-count")
      .html(cart.qty + " item" + (cart.qty != 1 ? "s" : ""));
    byob_summary.find("#byob-subtotal").html(formatCC(cart.subtotal));
    byob_summary
      .find("#byob-discount")
      .html(byob_discount_name ? "(" + byob_discount_name + ")" : "");
  }
  function checkTrackerBYOB(that, ids) {
    let items = $(that).data("items");
    if (items.length) {
      items = items.split(",");
      for (let k = 0; k < ids.length; k++) {
        if (items.includes(ids[k])) {
          return true;
        }
      }
      return false;
    }
    return true;
  }
  function setTrackerBYOB(that, percent, j) {
    setTimeout(() => {
      let point = $(that).find(".point:not(.start)");
      if (percent >= 100) {
        point.addClass("active");
      } else {
        point.removeClass("active");
      }
      $(that)
        .find(".process")
        .css("width", percent + "%");
    }, j * 600);
    return ++j;
  }
  function loadProductBYOB() {
    let cart = getCartBYOB();
    let products = $(".byob-product");
    for (let i = 0; i < products.length; i++) {
      let product = $(products[i]);
      let item = { key: "", quantity: 1 };
      let index = cart.ids.indexOf(product.data("product-options").id);
      if (index !== -1) {
        item = cart.items[index];
      }
      toggleInputBtn(product, item.key != "");
      product.attr("data-key", item.key).data("key", item.key);
      product.find(".t4s-quantity-input").val(item.quantity);
    }
    $(".t4s-products").removeClass("disabled");
  }
  function removeListLoading(element) {
    let byod_loadings = $(element).find(".byob-loading");
    for (let i = 0; i < byod_loadings.length; i++) {
      $(byod_loadings[i]).removeClass("byob-loading");
    }
  }
  function toggleInputBtn(product, has_item = false) {
    product.find(".byob-loading").removeClass("byob-loading");
    product
      .find(".byob-quantity-wrapper")
      .css("display", has_item ? "inline-block" : "none");
    product
      .find(".add-to-byob")
      .css("display", !has_item ? "inline-block" : "none");
  }
  function getCartBYOB() {
    let data = {
      items: [],
      ids: [],
      qty: 0,
      subtotal: 0,
      total: 0,
      totals: [],
    };
    let items = Shopify.cart.items;
    for (let i = 0; i < items.length; i++) {
      let item = items[i];
      if (item.properties.Bundle == "BYOB") {
        data.items.push(item);
        data.ids.push(item.product_id.toString());
        data.qty += item.quantity;
        data.subtotal += item.line_price;
        data.total += item.original_line_price;
        data.totals.push(item.original_line_price);
      }
    }
    return data;
  }
  function getPointValue() {
    let points = $("#byob-tracker").find(".point");
    for (let i = 0; i < points.length; i++) {
      let el = $(points[i]);
      let point = 0;
      if (!el.hasClass("start")) {
        point = currencyWithRate(el.parent().data("point"));
        el.parent().attr("data-point", point);
      }
      el.find(".value").html(formatCC(point * 100, 0));
    }
  }
  function myApiCart(that) {
    let cart = MyAPI.cart;
    cart.setPreLoad(() => {
      $(".t4s-products").addClass("disabled");
      $(that).addClass("byob-loading");
    });
    cart.setAfterLoad(() => {
      try {
        T4SThemeSP.Cart.getToFetch();
      } catch (e) {}
    });
    return cart;
  }
  function initBYOB() {
    getPointValue();
    removeListLoading("#byob-tracker");
    removeListLoading("#byob-cart");
    removeListLoading(".t4s-pr.t4s-tab-contents2");
    scrollBYOBSummary();
    scrollBYOBCart();
  }
  function scrollBYOBSummary() {
    const footer = document.querySelector("#shopify-section-footer");
    const byob_summary = document.querySelector("#byob-summary");
    const byob_cart = document.querySelector("#byob-cart");
    let prevScrollPos = window.pageYOffset;
    const scrollSummary = () => {
      let bottom = "-100%";
      let limitBottom = window.pageYOffset - footer.getBoundingClientRect().top;
      if (
        (prevScrollPos < window.pageYOffset && prevScrollPos > limitBottom) ||
        window.pageYOffset < byob_cart.getBoundingClientRect().bottom
      ) {
        bottom = "0%";
      }
      byob_summary.style.bottom = bottom;
      prevScrollPos = window.pageYOffset;
    };
    scrollSummary();
    window.addEventListener("scroll", scrollSummary);
  }
  function scrollBYOBCart() {
    const slider = document.getElementById("byob-cart");
    let isDown = false;
    let startX;
    let scrollLeft;
    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      slider.style.cursor = "grab";
    });
    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.style.cursor = "unset";
    });
    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.style.cursor = "unset";
    });
    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5;
      slider.scrollLeft = scrollLeft - walk;
    });
  }
});
